import { DialogConfig } from '@angular/cdk/dialog';

// Define available dialog styles
export type DialogStyles = 'SMALL' | 'BIG' | 'FULL_SCREEN';

// Shared base configuration for all dialogs
const BaseDialogConfig: DialogConfig = {
  // disableClose: true,
};

// Small desktop-style dialog configuration
const SmallDialogConfig: DialogConfig = {
  ...BaseDialogConfig,
  panelClass: 'dialog-small',
};

// Large desktop-style dialog configuration
const BigDialogConfig: DialogConfig = {
  ...BaseDialogConfig,
  panelClass: 'dialog-big',
};

// Full screen
const FullScreenDialogConfig: DialogConfig = {
  ...BaseDialogConfig,
  panelClass: 'dialog-full-screen',
};

// Map to associate styles with their configurations
const DialogStylesMap: Record<DialogStyles, DialogConfig> = {
  SMALL: SmallDialogConfig,
  BIG: BigDialogConfig,
  FULL_SCREEN: FullScreenDialogConfig,
};

/**
 * Returns the dialog configuration for the given style.
 * Falls back to base config if the style is not recognized.
 *
 * @param style - The dialog style name
 * @returns DialogConfig - Corresponding configuration object
 */
export function getDialogStyle(style: DialogStyles): DialogConfig {
  return DialogStylesMap[style] ?? BaseDialogConfig;
}
